import { fetcher } from "./defaultFetcher";
import axios from "axios";

type AuthProps = {
  email: string;
  password: string;
};

type SignUpProps = {
  teamId?: string;
  firstname?: string;
  lastname?: string;
  username?: string;
  customInviteCode?: string;
  inviteCode?: string;
  email: string;
  password: string;
  gdprCompliance: boolean;
};
async function generalSignUp(
  {
    email,
    password,
    firstname,
    lastname,
    username,
    gdprCompliance,
    teamId,
    customInviteCode,
    inviteCode,
  }: SignUpProps,
  url: string
) {
  return fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      email,
      password,
      firstname,
      lastname,
      username,
      teamId,
      customInviteCode,
      inviteCode,
    }),
  }).then(async (res) => {
    if (res.status === 403) {
      const jsonError = await res.json();
      const error = new Error(jsonError.message ?? "Keine Berechtigung");
      // @ts-ignore
      error.status = 403;
      throw error;
    } else if (res.status >= 400) {
      const jsonError = await res.json();
      const error = new Error(
        jsonError.message ?? "Ein Fehler ist aufgetreten"
      );
      // @ts-ignore
      error.status = res.status;
      throw error;
    } else {
      const data = await res.json();
      return { user: data?.user ?? null };
    }
  });
}

export async function signUp(data: SignUpProps) {
  return generalSignUp(data, "/api/v0/auth/signup");
}
export async function memberSignUp(data: SignUpProps) {
  return generalSignUp(data, "/api/v0/auth/member-signup");
}
export async function signIn({ email, password }: AuthProps) {
  return fetch("/api/v0/auth/signin", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "same-origin",
    body: JSON.stringify({
      email,
      password,
    }),
  }).then(async (res) => {
    if (res.status === 403) {
      const json = await res.json();
      const error = new Error(json.message || "Not authorized!");
      // @ts-ignore
      error.status = 403;
      throw error;
    } else {
      const user = await res.json();
      return { user: user ?? null };
    }
  });
}
export async function signOut() {
  return axios({
    method: "POST",
    url: "/api/v0/auth/signout",
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: true,
  });
}

export async function sendResetPasswordEmail(
  email: string,
  teamLogo?: string,
  teamName?: string
) {
  return fetch("/api/v0/auth/resetPasswordEmail", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      email,
      teamName,
      teamLogo,
    }),
  }).then(async (res) => {
    if (res.status === 403) {
      const response = await res.json();
      const error = new Error(response.message || "Nicht authorisiert");
      // @ts-ignore
      error.status = 403;
      throw error;
    } else {
      const success = await res.json();
      return success;
    }
  });
}

export async function resetPasswordWithId(
  newPassword: string,
  id: string,
  teamLogo?: string,
  teamName?: string
) {
  return fetch("/api/v0/auth/resetPasswordWithId", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      newPassword,
      verificationId: id,
      teamName,
      teamLogo,
    }),
  }).then(async (res) => {
    if (res.status === 403) {
      const response = await res.json();
      const error = new Error(response.message || "Nicht authorisiert");
      // @ts-ignore
      error.status = 403;
      throw error;
    } else {
      const success = await res.json();
      return success;
    }
  });
}
